// extracted by mini-css-extract-plugin
export default {"modalContain":"src-pages-Order-Components-MarkAsPaid-css-module__modalContain--tKNeI"};